<!-- 莆田信用卡用户国庆抽奖 -->
<template>
  <div
    :class="{
      'page-100vh': page100vh,
      'putian-postal-national-day-lottery': true,
    }"
  >
    <div class="top"></div>
    <img
      src="@/assets/imgs/putianPostalNationalDayLottery/title.png"
      class="title"
      alt=""
    />
    <div class="grid-container" v-if="showLuckDraw">
      <div class="grid-box">
        <LuckyGrid
          ref="LuckDraw"
          width="7.8rem"
          height="7.8rem"
          :prizes="prizes"
          :buttons="buttons"
          :blocks="blocks"
          :default-config="defaultConfig"
          :default-style="defaultStyle"
          :active-style="activeStyle"
          @start="startCallBack"
          @end="endCallBack"
        />
        <div class="btn-row">
          <img
            src="@/assets/imgs/putianPostalNationalDayLottery/btn2.png"
            alt=""
            class="btn1"
            @click="openPrizesPopup"
          />
          <img
            src="@/assets/imgs/putianPostalNationalDayLottery/btn3.png"
            alt=""
            @click="() => $refs.rulePopupRef.setShow(true)"
          />
        </div>
      </div>
    </div>
    <div class="qr-code" v-if="showLuckDraw">
      <img src="@/assets/imgs/putianPostalNationalDayLottery/pic4.png" alt="" />
      <p>{{ "邮储银行福利群\n查看更多优惠！" }}</p>
    </div>
    <ResultPopup ref="resultPopupRef" />
    <RulePopup ref="rulePopupRef" />
    <PrizesPopup ref="prizesPopupRef" @close="closePrizesPopup" />
    <LocationPopup ref="locationPopupRef" @submit="saveSystemArea" />
  </div>
</template>

<script>
import ResultPopup from './components/ResultPopup.vue'
import RulePopup from './components/RulePopup.vue'
import PrizesPopup from './components/PrizesPopup.vue'
import LocationPopup from './components/LocationPopup.vue'
import {
  login,
  getUserInfo,
  registerUserInfo,
  qqnbcl,
} from '@/api/psbcNationalDayLottery'
import { getLocation } from '@/utils/location'
import moment from 'moment'
import { encryption } from '@/utils/common'
export default {
  name: 'Play',
  components: { ResultPopup, RulePopup, PrizesPopup, LocationPopup },
  computed: {},
  data() {
    return {
      title: '莆田邮储信用卡国庆抽奖',
      prizes: [], // 九宫格使用的奖品列表，样式1
      sortList: [], // 排序后的奖品列表，取数据使用
      blocks: [
        // 背景的配置
        // { padding: '50', background: '#ffc27a', borderRadius: 20 },
      ],
      defaultConfig: {
        gutter: 5
      },
      defaultStyle: {
        // 奖品格子配置
        borderRadius: 15,
        fontColor: '#430a15',
        fontSize: '10px',
        textAlign: 'center',
        background: '#ffcaa5',
        shadow: '0 30 1 #ffdbbf'
      },
      activeStyle: {
        background: '#fbb28e'
      },
      // 中间抽奖按钮的配置
      buttons: [
        {
          x: 1,
          y: 1,
          imgs: [
            {
              src: require('@/assets/imgs/putianPostalNationalDayLottery/btn1.png'),
              width: '100%',
              top: '0'
            }
          ]
        }
      ],
      userInfo: {
        // private String token; 当日这个openid是否有抽奖成功的记录 0否1是
        // private Integer lotteryCountStatus; 当日这个openid是否有用户已达最大领券次数的记录 0否1是
        // private Integer ruleLimitCountStatus; 当日抽奖成功次数是否小于每日总限制次数 0否1是
        // private Integer daylimitCountStatus;
        // private String longitude;  经度
        // private String latitude;  纬度
        // private String city;  市区
      }, // 用户信息
      btnDisbaled: false,
      lotteryData: {},
      page100vh: false,
      showLuckDraw: false,
    }
  },
  created() {
    //首页回退禁用
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', this.popstatehandle)

    document.title = this.title
    // 图片加载完成，显示转盘
    this.preFetchImg().then(() => {
      this.getPrizeList()
      this.showLuckDraw = true
    })

    if (sessionStorage.getItem('psbcNationalDayLotteryToken')) {
      this.getUserInfo()
    } else {
      this.login()
    }
  },
  methods: {
    login() {
      login({
        code: sessionStorage.getItem('ydsh-ph-h5-bankv3-wxcode')
      }).then(res => {
        if (res.code === 0) {
          sessionStorage.setItem('psbcNationalDayLotteryToken', res.data.token)
          this.setUserInfo(res.data)
        } else {
          this.openError(res.message)
        }
      })
    },
    getUserInfo() {
      getUserInfo({ urlToken: this.urlToken }).then(res => {
        if (res.code === 0) {
          this.setUserInfo(res.data)
        }
      })
    },
    // 获取定位保存并判断是否符合条件
    saveSystemArea() {
      getLocation().then(coordinate => {
        registerUserInfo({
          ...coordinate,
        }).then(res => {
          // 满足位置
          this.$toast.success('位置保存成功!')
          this.$refs.locationPopupRef.setShow(false)
          this.getUserInfo()
        })
      })
    },
    // 抽奖
    startCallBack() {
      if (this.openSetLocationPopup()) return
      if (this.btnDisbaled) return console.log('请不要重复点击');
      let str = 'yidain' + moment().format('YYYYMMDDHHmmss') + this.getMathRand()
      let encryptionStr = encryption(str)
      this.$refs.LuckDraw.play()
      this.lotteryData = {}
      this.btnDisbaled = true
      qqnbcl({ voucher: encryptionStr }).then(res => {
        // console.log('then==', res);
        // let res =
        // {
        //   "code": 0, "data": {
        //     "prizeId": 617,
        //     "prizeName": "51元微信立减金",
        //     "status": 0
        //   }, "message": "操作成功"
        // }
        this.btnDisbaled = false
        if (res.data.status === 0) {
          this.$refs.LuckDraw.stop()
          this.openErrorPopup('当前参与人数较多，请稍后重试')
        } else {
          this.lotteryData = res.data
          let index = this.sortList.findIndex(i => {
            return i.name === res.data.prizeName
          })
          setTimeout(() => {
            if (index === -1) {
              this.$refs.LuckDraw.stop(index + 1)
            } else {
              this.$refs.LuckDraw.stop()
              console.log('没有找到奖品');
            }
          }, 500)
        }
      }).catch((res) => {
        this.btnDisbaled = false
        // console.log('catch==', res);
        this.$refs.LuckDraw.stop()
        this.openErrorPopup(res.message)
      })
    },
    endCallBack() {
      if (this.lotteryData.prizeName) {
        this.openSuccessPopup(`获得${this.lotteryData.prizeName}`)
      }
      this.$refs.LuckDraw.init()
    },
    //随机六位数
    getMathRand() {
      var Num = "";
      for (var i = 0; i < 6; i++) {
        Num += Math.floor(Math.random() * 10);
      }
      return Num
    },
    // 错误信息弹窗
    openErrorPopup(msg) {
      this.$refs.resultPopupRef.iconKey = 1
      this.$refs.resultPopupRef.title = ''
      this.$refs.resultPopupRef.message = msg
      this.$refs.resultPopupRef.setShow(true)
    },
    // 成功信息弹窗
    openSuccessPopup(msg) {
      this.$refs.resultPopupRef.iconKey = 0
      this.$refs.resultPopupRef.title = '恭喜您'
      this.$refs.resultPopupRef.message = msg
      this.$refs.resultPopupRef.setShow(true)
    },
    setUserInfo(data) {
      this.userInfo = data
      this.openSetLocationPopup()
    },
    // 没有城市，去设置位置弹窗
    openSetLocationPopup() {
      if (!this.userInfo.city) {
        this.$refs.locationPopupRef.setShow(true)
        return true
      }
      return false
    },
    //获取页面奖品列表
    async getPrizeList() {
      let list = [
        {
          name: '中石化15元微信立减金',
          prizeUrl: require('@/assets/imgs/putianPostalNationalDayLottery/icon1.png'),
          prizePosition: `3,6`
        },
        {
          name: '1元微信立减金',
          prizeUrl: require('@/assets/imgs/putianPostalNationalDayLottery/icon2.png'),
          prizePosition: `2,7`
        },
        {
          name: '5元微信立减金',
          prizeUrl: require('@/assets/imgs/putianPostalNationalDayLottery/icon2.png'),
          prizePosition: `1,5`
        },
        {
          name: '10元饿了么/美团微信立减金',
          prizeUrl: require('@/assets/imgs/putianPostalNationalDayLottery/icon3.png'),
          prizePosition: `4,8`
        },
      ]
      const sortList = this.formatPrizeList(list)
      this.setPrizeList(sortList)
    },
    formatPrizeList(list) {
      // 对奖品数据进行格式化处理
      // 根据prizePosition数组将奖品复制多份，按照需求排序
      const list1 = []
      list.map(item => {
        const positionIdArr = item.prizePosition.split(',')
        positionIdArr.map(p => {
          const newItem = {
            name: item.name,
            img: item.prizeUrl,
            positionId: parseInt(p),
          }
          list1.push(newItem)
        })
      })
      const sortList = []
      const sortIndex = [1, 2, 3, 5, 8, 7, 6, 4]
      sortIndex.map(i => {
        const one = list1.find(j => j.positionId === i)
        sortList.push(one)
      })
      this.sortList = sortList
      return sortList
    },
    setPrizeList(data) {
      // 模拟接口请求奖品列表
      const prizes = []
      const axis = [
        [0, 0],
        [1, 0],
        [2, 0],
        [2, 1],
        [2, 2],
        [1, 2],
        [0, 2],
        [0, 1]
      ]
      for (let i = 0; i < 8; i++) {
        const item = data[i]
        // 奖品列表区域的样式
        prizes.push({
          index: i,
          x: axis[i][0],
          y: axis[i][1],
          fonts: [{
            text: item.name,
            top: item.name.length > 7 ? '90%' : '105%',
            fontColor: '#ff0000',
            wordWrap: 'true',
            lineHeight: '14px',
            fontSize: '12px'
          }],
          imgs: [{ src: item.img, width: '46%', top: '18%' }]
        })
      }
      this.prizes = prizes
    },
    popstatehandle() {
      history.pushState(null, null, document.URL)
      if (this.isWechat()) {
        // eslint-disable-next-line
        wx.closeWindow();
        //微信
      } else {
        window.close()
      }
    },
    isWechat() {
      return /MicroMessenger/i.test(window.navigator.userAgent);
    },
    // 页面图片预先加载
    preFetchImg() {
      return new Promise((resolve, reject) => {
        let imgs = [
          require("@/assets/imgs/putianPostalNationalDayLottery/l_bg.png"),
          require("@/assets/imgs/putianPostalNationalDayLottery/icon1.png"),
          require("@/assets/imgs/putianPostalNationalDayLottery/icon2.png"),
          require("@/assets/imgs/putianPostalNationalDayLottery/icon3.png"),
          require("@/assets/imgs/putianPostalNationalDayLottery/btn1.png"),
          require("@/assets/imgs/putianPostalNationalDayLottery/pic1.png"),
          require("@/assets/imgs/putianPostalNationalDayLottery/pic2.png"),
        ]
        let sum = imgs.length
        let num = 0
        for (let img of imgs) {
          let image = new Image()
          image.src = img
          image.onload = () => {
            // 图片加载完整
            num++
            if (sum === num) {
              resolve()
            }
          }
        }
      })
    },
    openPrizesPopup() {
      this.page100vh = true
      this.$refs.prizesPopupRef.setShow(true)
    },
    closePrizesPopup() {
      this.page100vh = false
    },

  }
}
</script>

<style lang="less" scoped>
.putian-postal-national-day-lottery {
  width: 100%;
  min-height: 100vh;
  background: url("../../../assets/imgs/putianPostalNationalDayLottery/bg.jpg")
    no-repeat;
  background-size: 100% auto;
  text-align: center;
  .top {
    width: 100%;
    height: 20px;
  }
  .title {
    width: 297px;
  }
  .grid-container {
    padding-top: 10px;
    position: relative;

    .grid-box {
      width: 375px;
      height: 505px;
      padding-top: 55px;
      padding-left: 42px;
      padding-right: 42px;
      box-sizing: border-box;
      background: url("../../../assets/imgs/putianPostalNationalDayLottery/l_bg.png")
        no-repeat;
      background-size: cover;
      background-position: center;
    }
    .btn-row {
      margin-top: 45px;
      img {
        width: 110px;
      }
      .btn1 {
        margin-right: 30px;
      }
    }
  }
  .qr-code {
    margin-top: -60px;
    padding-bottom: 10px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 80px;
    }
    p {
      margin-left: 10px;
      font-size: 11px;
      color: #000000;
      line-height: 1.5;
      white-space: pre-line;
    }
  }
}
.page-100vh {
  height: 100vh;
  overflow: hidden;
}
</style>
